'use client';
import { useContactForm } from '@/app/hooks/useContactForm';
import Link from 'next/link';
import React from 'react';
import { TbMailForward } from 'react-icons/tb';

const ContactForm: React.FC = () => {
  const {
    input,
    error,
    isLoading,
    handleInputChange,
    handleBlur,
    handleSubmit,
  } = useContactForm();

  return (
    <div className="">
      <p className="font-medium mb-5 text-[#16f2b3] text-xl uppercase">
        Contact with me
      </p>
      <div className="max-w-3xl text-white rounded-lg border border-[#464c6a] p-3 lg:p-5">
        <p className="text-sm text-[#d3d8e8]">
          {
            "If you have any questions or concerns, please don't hesitate to contact me. I am open to any work opportunities that align with my skills and interests."
          }
        </p>
        <div className="mt-6 flex flex-col gap-4">
          <div className="flex flex-col gap-2">
            <label htmlFor="name" className="text-base">
              Your Name:{' '}
            </label>
            <input
              id="name"
              className="bg-[#10172d] w-full border rounded-md border-[#353a52] focus:border-[#16f2b3] ring-0 outline-0 transition-all duration-300 px-3 py-2"
              type="text"
              maxLength={100}
              required={true}
              name="name"
              autoComplete="name"
              onChange={handleInputChange}
              onBlur={handleBlur}
              value={input.name}
            />
          </div>

          <div className="flex flex-col gap-2">
            <label htmlFor="email" className="text-base">
              Your Email:{' '}
            </label>
            <input
              id="email"
              className="bg-[#10172d] w-full border rounded-md border-[#353a52] focus:border-[#16f2b3] ring-0 outline-0 transition-all duration-300 px-3 py-2"
              type="email"
              maxLength={100}
              required={true}
              name="email"
              autoComplete="email"
              value={input.email}
              onChange={handleInputChange}
              onBlur={handleBlur}
            />
            {error.email && (
              <p className="text-sm text-red-400">
                Please provide a valid email!
              </p>
            )}
          </div>

          <div className="flex flex-col gap-2">
            <label htmlFor="message" className="text-base">
              Your Message:{' '}
            </label>
            <textarea
              id="message"
              className="bg-[#10172d] w-full border rounded-md border-[#353a52] focus:border-[#16f2b3] ring-0 outline-0 transition-all duration-300 px-3 py-2"
              maxLength={500}
              name="message"
              required={true}
              onChange={handleInputChange}
              onBlur={handleBlur}
              rows={4}
              value={input.message}
            />
          </div>
          <div className="flex flex-col items-center gap-2">
            <p className="text-xs text-gray-400 text-center">
              This site is protected by reCAPTCHA and the Google{' '}
              <Link
                href="https://policies.google.com/privacy"
                target="_blank"
                rel="noopener noreferrer"
                className="text-[#16f2b3] underline hover:no-underline"
              >
                Privacy Policy
              </Link>{' '}
              and{' '}
              <Link
                href="https://policies.google.com/terms"
                target="_blank"
                rel="noopener noreferrer"
                className="text-[#16f2b3] underline hover:no-underline"
              >
                Terms of Service
              </Link>{' '}
              apply.
            </p>
            {error.required && (
              <p className="text-sm text-red-400">
                Email and Message are required!
              </p>
            )}
            {error.recaptcha && (
              <p className="text-sm text-red-400">
                reCAPTCHA verification failed. Please try again.
              </p>
            )}
            <button
              className="flex items-center gap-1 hover:gap-3 rounded-full bg-gradient-to-r from-pink-500 to-violet-600 px-5 md:px-12 py-2.5 md:py-3 text-center text-xs md:text-sm font-medium uppercase tracking-wider text-white no-underline transition-all duration-200 ease-out hover:text-white hover:no-underline md:font-semibold disabled:opacity-50"
              role="button"
              onClick={() => void handleSubmit()}
              disabled={isLoading}
            >
              {isLoading ? <span>Sending...</span> : <span>Send Message</span>}
              {!isLoading && <TbMailForward className="mt-1" size={18} />}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ContactForm;
